import {
  LOGIN_SUCCESS,
  LOGOUT_REQUEST,
  UPDATE_USER,
  SET_PERSONAL_DATA,
} from "./actionType";

export function saveLoginUserData(response) {
  return { type: LOGIN_SUCCESS, payload: response };
}
export function updateUserData(response) {
  return { type: UPDATE_USER, payload: response };
}

export function signOutRequest() {
  return {
    type: LOGOUT_REQUEST,
  };
}

export function setPersonalData(type, data) {
  return {
    type: SET_PERSONAL_DATA,
    payload: { type, data },
  };
}
